module.exports = __webpack_public_path__ + "tg.svg?aff94a793ed8d936373717694ddf3d99";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/tg.svg
// module id = 1388
// module chunks = 0